import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import CalendarProps from './CalendarProps'

import Messages from './Messages'
import Month from '../Common/Month'

export default {
    props: CalendarProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Messages,
        Month
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoCalendar(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoCalendar()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoCalendar/KendoCalendarMixin.js